import type { ChangeEvent } from 'react';
import { FormGroup, FormSection, TextArea } from '@ksyos/design-system';
import type { ProcessActivityAnamnesis } from '@common/validation/customControls/processActivityAnamnesisData';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';

interface ProcessActivityAnamnesisAddEditProps {
    anamnesis: ProcessActivityAnamnesis;
    errors: ValidationErrors;
    onChange: (data: { anamnesis: ProcessActivityAnamnesis }, validateKeys?: string | string[] | undefined) => void;
}

export function ProcessActivityAnamnesisAddEdit(props: ProcessActivityAnamnesisAddEditProps) {
    const { anamnesis, errors, onChange } = props;
    const translate = getSelectedLanguage();

    return (
        <FormSection title={translate.anamnesis.anamnesis}>
            <FormGroup
                hasErrors={errors.has('anamnesis.complaints')}
                isRequired={true}
                label={translate.anamnesis.complaints}
            >
                <TextArea
                    error={getValidationErrorTranslation(errors.get('anamnesis.complaints'))}
                    name="complaints"
                    onChange={onChangeEvent}
                    value={anamnesis.complaints}
                />
            </FormGroup>

            <FormGroup
                hasErrors={errors.has('anamnesis.history')}
                isRequired={true}
                label={translate.anamnesis.history}
            >
                <TextArea
                    error={getValidationErrorTranslation(errors.get('anamnesis.history'))}
                    name="history"
                    onChange={onChangeEvent}
                    value={anamnesis.history}
                />
            </FormGroup>

            <FormGroup
                hasErrors={errors.has('anamnesis.familyHistory')}
                isRequired={true}
                label={translate.anamnesis.familyHistory}
            >
                <TextArea
                    error={getValidationErrorTranslation(errors.get('anamnesis.familyHistory'))}
                    name="familyHistory"
                    onChange={onChangeEvent}
                    value={anamnesis.familyHistory}
                />
            </FormGroup>
        </FormSection>
    );

    function onChangeEvent(event: ChangeEvent<HTMLTextAreaElement>) {
        onChange(
            {
                anamnesis: {
                    ...anamnesis,
                    [event.target.name]: event.target.value,
                },
            },
            `anamnesis.${event.target.name}`
        );
    }
}
